<template>
  <!-- 操作按钮组 -->
  <div>
    <el-tooltip v-if="buttons.includes('columnDisplay')" content="自定义列" placement="top">
      <el-dropdown style="margin-right: 10px;" v-if="buttons.includes('columnDisplay')" :max-height="380"
                   :hide-on-click="false">
        <el-button class="btn" color="#40485b" type="info">
          <el-icon size="18" color="#ffffff">
            <Setting/>
          </el-icon>
        </el-button>
        <template #dropdown>
          <el-dropdown-menu>
            <template v-for="(item, index) in tableData.column" :key="index">
              <el-dropdown-item v-if="item.label&&item.prop&&(item.visible===false?false:true)">
                <el-checkbox @change="onChangeShowColumn(item)" :checked="item.show"
                             :model-value="item.show" size="small" :value="item.label">
                  {{ item.label }}
                </el-checkbox>
              </el-dropdown-item>
            </template>
          </el-dropdown-menu>
        </template>
      </el-dropdown>
    </el-tooltip>
    <el-button class="btn" v-if="buttons.includes('save')" @click="onAction('save')" type="primary">
      <el-icon size="18">
        <svg-icon icon-class="save"></svg-icon>
      </el-icon>
      <span>保存</span>
    </el-button>
    <el-button class="btn" v-if="buttons.includes('back')" @click="onAction('back')" type="primary">
      <el-icon size="18">
        <svg-icon icon-class="back"></svg-icon>
      </el-icon>
      <span>返回</span>
    </el-button>
    <el-tooltip v-if="buttons.includes('refresh')" content="刷新" placement="top">
      <el-button class="btn" @click="onAction('refresh')" color="#40485b" type="info">
        <el-icon size="18" color="#ffffff">
          <Refresh/>
        </el-icon>
      </el-button>
    </el-tooltip>
    <el-button class="btn" v-if="buttons.includes('add')" @click="onAction('add')" type="primary"
               v-access="access[buttons.indexOf('add')]">
      <el-icon size="18" color="#ffffff">
        <Plus/>
      </el-icon>
      <span>新建</span>
    </el-button>
    <el-button class="btn" v-if="buttons.includes('audit')" @click="onAction('audit')" type="success"
               v-access="access[buttons.indexOf('audit')]">
      <el-icon size="18" color="#ffffff">
        <DocumentChecked/>
      </el-icon>
      <span>审核</span>
    </el-button>
    <el-button class="btn" v-if="buttons.includes('edit')" @click="onAction('edit')" type="primary"
               v-access="access[buttons.indexOf('edit')]">
      <el-icon size="18" color="#ffffff">
        <EditPen/>
      </el-icon>
      <span>编辑</span>
    </el-button>
    <el-button class="btn" v-if="buttons.includes('delete')" @click="onAction('delete')" type="danger"
               v-access="access[buttons.indexOf('delete')]">
      <el-icon size="18" color="#ffffff">
        <Delete/>
      </el-icon>
      <span>删除</span>
    </el-button>
    <el-button class="btn" v-if="buttons.includes('down')" @click="onAction('down')" type="primary"
               v-access="access[buttons.indexOf('down')]">
      <el-icon size="18" color="#ffffff">
        <Download/>
      </el-icon>
      <span>下载</span>
    </el-button>
    <el-button class="btn" v-if="buttons.includes('zancun')" @click="onAction('zancun')" type="primary"
               v-access="access[buttons.indexOf('zancun')]">
      <el-icon size="18">
        <svg-icon icon-class="zancun"></svg-icon>
      </el-icon>
      <span>暂存</span>
    </el-button>
    <el-button class="btn" v-if="buttons.includes('clear')" @click="onAction('clear')" type="primary"
               v-access="access[buttons.indexOf('clear')]">
      <el-icon size="18">
        <svg-icon icon-class="qingkong"></svg-icon>
      </el-icon>
      <span>清空</span>
    </el-button>
    <el-button class="diy" v-if="buttons.includes('diy')" @click="onAction('diy')" :type="diy.type"
               v-access="access[buttons.indexOf('diy')]">
      <el-icon size="18">
        <component :is="diy.icon"></component>
      </el-icon>
      <span>{{ diy.text }}</span>
    </el-button>
    <el-button class="diy1" v-if="buttons.includes('diy1')" @click="onAction('diy1')" :type="diy1.type"
               v-access="access[buttons.indexOf('diy1')]">
      <el-icon size="18">
        <component :is="diy1.icon"></component>
      </el-icon>
      <span>{{ diy1.text }}</span>
    </el-button>
    <el-button class="diy2" v-if="buttons.includes('diy2')" @click="onAction('diy2')" :type="diy2.type"
               v-access="access[buttons.indexOf('diy2')]">
      <el-icon size="18">
        <component :is="diy2.icon"></component>
      </el-icon>
      <span>{{ diy2.text }}</span>
    </el-button>
    <el-button class="diy3" v-if="buttons.includes('diy3')" @click="onAction('diy3')" :type="diy3.type"
               v-access="access[buttons.indexOf('diy3')]">
      <el-icon size="18">
        <component :is="diy3.icon"></component>
      </el-icon>
      <span>{{ diy3.text }}</span>
    </el-button>
    <el-button class="diy4" v-if="buttons.includes('diy4')" @click="onAction('diy4')" :type="diy4.type"
               v-access="access[buttons.indexOf('diy4')]">
      <el-icon size="18">
        <component :is="diy4.icon"></component>
      </el-icon>
      <span>{{ diy4.text }}</span>
    </el-button>
    <el-button class="diy5" v-if="buttons.includes('diy5') && diy5.show" @click="onAction('diy5')" :type="diy5.type"
               v-access="access[buttons.indexOf('diy5')]">
      <el-icon size="18">
        <svg-icon v-if="diy5.svg" :icon-class="diy5.svg"></svg-icon>
        <component v-if="diy5.icon" :is="diy5.icon"></component>
      </el-icon>
      <span>{{ diy5.text }}</span>
    </el-button>
    <el-button class="diy6" :style="diy6.style" v-if="buttons.includes('diy6') && diy6.show" @click="onAction('diy6')" :type="diy6.type"
               v-access="access[buttons.indexOf('diy6')]">
      <el-icon size="18">
        <svg-icon v-if="diy6.svg" :icon-class="diy6.svg"></svg-icon>
        <component v-if="diy6.icon" :is="diy6.icon"></component>
      </el-icon>
      <span v-if="diy6.text">{{ diy6.text }}</span>
    </el-button>
    <el-button class="diy7" v-if="buttons.includes('diy7') && diy7.show" @click="onAction('diy7')" :type="diy7.type"
                :style="diy7.style"
               v-access="access[buttons.indexOf('diy7')]">
      <el-icon size="18">
        <svg-icon v-if="diy7.svg" :icon-class="diy7.svg"></svg-icon>
        <component v-if="diy7.icon" :is="diy7.icon"></component>
      </el-icon>
      <span>{{ diy7.text }}</span>
    </el-button>
    <el-button class="diy8" v-if="buttons.includes('diy8') && diy8.show" @click="onAction('diy8')" :type="diy8.type"
               :style="diy8.style"
               v-access="access[buttons.indexOf('diy8')]">
      <el-icon size="18">
        <svg-icon v-if="diy8.svg" :icon-class="diy8.svg"></svg-icon>
        <component v-if="diy8.icon" :is="diy8.icon"></component>
      </el-icon>
      <span>{{ diy8.text }}</span>
    </el-button>
  </div>
</template>

<script>
export default {
  name: "tableHeader",    //头部按钮组件
  props: {
    //显示的按钮数组 eg:['columnDisplay','refresh', 'add']
    buttons: {
      type: null,
      default: []
    },
    //显示的按钮数组权限, 空表示不鉴权,与buttons对应 eg:['','', '001']
    access: {
      type: null,
      default: []
    },
    //table数据,用于设置显示列
    tableData: {
      type: null,
      default: null
    },
    //diy自定义数据
    diy: {
      type: null,
      default: {text: '', type: 'primary', icon: 'Plus',}
    },
    diy1: {
      type: null,
      default: {text: '', type: 'primary', icon: 'Plus',}
    },
    diy2: {
      type: null,
      default: {text: '', type: 'primary', icon: 'Plus',}
    },
    diy3: {
      type: null,
      default: {text: '', type: 'primary', icon: 'Plus',}
    },
    diy4: {
      type: null,
      default: {text: '', type: 'primary', icon: 'Plus',}
    },
    diy5: {
      type: Object,
      default: {text: '', type: 'primary', icon: 'Plus',show:true}
    },
    diy6: {
      type: Object,
      default: {text: '', type: 'primary', icon: 'Plus',show:true}
    },
    diy7: {
      type: Object,
      default: {text: '', type: 'primary', icon: 'Plus',show:true,style:{},}
    },
    diy8: {
      type: Object,
      default: {text: '', type: 'primary', icon: 'Plus',show:true,style:{},}
    },
  },
  data() {
    return {
      isShake: false,      //按钮防抖
    }
  },
  methods: {

    /**
     * 事件点击
     */
    onAction(e) {
      if (this.isShake) {
        return;
      }
      this.isShake = true;
      setTimeout(res => {
        this.isShake = false;
      }, 1000);
      switch (e) {
        case 'refresh':
          //循环清空表单数据
          for (let i = 0; i < this.tableData.column.length; i++) {
            if (this.tableData.column[i].condition) {
              this.tableData.form[this.tableData.column[i].prop] = ""
            }
          }
          if (this.tableData.form && this.tableData.form.page) {
            this.tableData.form.page = 1;
          }
          return this.tableData.searchClick();
          break;
        case 'delete':
          this.$confirm("确定要删除选中的数据么?", {
            confirmButtonText: '删除',
            cancelButtonText: '取消',
            type: 'warning'
          }).then(() => {
            this.$emit("btnClick", e);
          });
          break;
        case 'audit':
          this.$confirm("确定要审核选中的数据么?", {
            confirmButtonText: '审核',
            cancelButtonText: '取消',
            type: 'warning'
          }).then(() => {
            this.$emit("btnClick", e);
          });
          break;
        default:
          this.$emit("btnClick", e);
          break
      }
    },

    /**
     * 选择改变
     */
    onChangeShowColumn: function (e) {
      //设置记录缓存的集合
      let columnSet = [];
      for (let i = 0; i < this.tableData.column.length; i++) {
        //改变选中值
        if (this.tableData.column[i].label == e.label && this.tableData.column[i].prop == e.prop) {
          this.tableData.column[i].show = !this.tableData.column[i].show
        }
        //加入集合
        columnSet.push({
          show: this.tableData.column[i].show ? true : false,
          label: this.tableData.column[i].label,
          prop: this.tableData.column[i].prop
        })
      }
      //存入缓存
      localStorage.setItem("column_" + this.$store.state.currRouter.name + "_" + this.$store.state.userInfo.id,
          JSON.stringify(columnSet));
    }
  }
}
</script>

<style scoped>
.btn {
  padding-left: 10px;
  padding-right: 10px;
}

</style>
